import { useEffect, useState } from "react";
import { getAllUserGroups } from "../services/groupService";

interface IUseFetchUserGroup {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const useFetchUserGroup = ({ setIsLoading }: IUseFetchUserGroup) => {
  const [userGroupData, setUserGroupData] = useState<any[]>([]);

  useEffect(() => {
    setIsLoading(true);
    const getUserGroupData = async () => {
      try {
        const res = await getAllUserGroups();
        setUserGroupData(res);
      } catch (err) {
        setUserGroupData([]);
      } finally {
        setIsLoading(false);
      }
    };
    getUserGroupData();
  }, []);

  return [userGroupData];
};

export default useFetchUserGroup;
